import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { toast } from 'react-toastify';
import Loader from '../../../Shared/Loader';
import logo from '../../../../assets/images/logo.jpeg';
import { useReactToPrint } from 'react-to-print';
import BusinessInfo from '../../../Shared/BusinessInfo';
import person from '../../../../assets/images/person.jpeg'

const CustomerLedgerReport = () => {
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [searchText, setSearchText] = useState();
    const [customerLedger, setCustomerLedger] = useState([]);
    const [opening, setOpening] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false)
    const [details, setDetails] = useState('');
    const [isFilter, setIsFilter] = useState(false);
    const componentRef = useRef();

    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    useEffect(() => {
        fetch(`https://servers.thakurgaonexpress.com/rupkotha/getmaincustomers`)
            .then(res => res.json())
            .then(data => {
                setCustomers(data);
                // setLoading(false)
            })
    }, [])

    const handleFilteredData = e => {
        e.preventDefault();
        const startDate = e.target.startDate.value;
        const endDate = e.target.endDate.value;
        const code = e.target.code.value;

        const options = {
            timeZone: 'Asia/Dhaka',
            hour12: false,
        };
        const currentTime = new Date().toLocaleString('en-US', options);

        const url = `https://servers.thakurgaonexpress.com/rupkotha/getcustomerledger?code=${code}&startDate=${startDate}&endDate=${endDate}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                console.log(data)
                setCustomerLedger(data.ledger);
                setOpening(data.opening);
                setIsFilter(true);
                setIsLoaded(true);
                setDetails({ startDate: startDate, name: selectedCustomer?.name, img: selectedCustomer?.img, code: code, range: startDate + " to " + endDate, time: currentTime });
                // setLoading(false)
            })

    }

    // const totalSaleAmount = customerLedger.reduce((total, currentValue) => {
    //     return total + parseInt(currentValue.totalAmount);
    // }, 0);
    const totalSaleAmount = customerLedger.reduce((total, currentValue) => {
        if (currentValue.remarks !== "Sales Return") {
            return total + parseInt(currentValue.totalAmount);
        }
        return total;
    }, 0);
    

    const totalSaleReturnAmount = customerLedger.reduce((total, currentValue) => {
        return total + parseInt(currentValue.salesReturn);
    }, 0);

    // const totalCollectionAmount = customerLedger.reduce((total, currentValue) => {
    //     if (currentValue.collection) {
    //         return total + parseInt(currentValue.collection);
    //     } else {
    //         return total;
    //     }
    // }, 0);

    const totalCollectionAmount = customerLedger.reduce((total, currentValue) => {
        const isSalesReturn = currentValue.remarks === "Sales Return";
        const collection = isSalesReturn ? 0 : parseFloat(currentValue.collection) || 0;
        const salesReturn = isSalesReturn ? (parseFloat(currentValue.salesReturn) || 0) : 0;
        return total + collection + salesReturn;
    }, 0);

    // if (loading) {
    //     return <Loader />
    // }
    const generatePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Bank Statement Of ${details?.accountName}`,

    })


    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = customers.filter(customer => customer.name.includes(searchText) ||
            customer.name.toLowerCase().includes(searchText) || customer.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleAddProductToInvoice = (customer) => {
        setSelectedCustomer(customer);
        setIsSearching(false)
        setSearchText('');
    }


    return (
        <div className='mx-2'>
            <h2 className='mt-8 text-center text-lg font-bold'>Customer Ledger Report</h2>
            <div className='flex flex-col lg:flex-row lg:justify-between lg:items-center'>
                <div className='lg:mt-28 mt-8 mr-2'>
                    <div className='flex flex-col lg:flex-row lg:justify-between lg:items-center'>
                        <div class="form-control w-80 lg:w-40 mx-auto">
                            <input onChange={handleSearchResult} value={searchText} type="text" placeholder="Search Customer" class="input text-xs input-bordered border-dark-purple w-80 mx-auto lg:w-60 max-w-xs" />
                        </div>
                    </div>
                    <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 mx-auto gap-2 bg-gray-200 p-2 ${isSearching ? 'h-60' : "h-8"} w-80 overflow-auto`}>
                        {
                            isSearching ? searchResult.map(customer =>
                                <label for="update-modal" onClick={() => handleAddProductToInvoice(customer)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{customer?.code}-{customer?.name}</label>) :
                                customers.map(customer =>
                                    <label for="update-modal" onClick={() => handleAddProductToInvoice(customer)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{customer?.code}-{customer?.name}</label>)
                        }
                    </div>
                </div>
                <div className='flex justify-center items-center lg:mr-20'>
                    <form onSubmit={handleFilteredData} className='mt-12 flex flex-col lg:flex-row justify-center items-center'>
                        <div class="form-control w-full mx-auto lg:w-40 max-w-xs lg:mr-2">
                            <label class="label">
                                <span class="label-text">Starting Date</span>
                            </label>
                            <input name='startDate' defaultValue={today} type="date" class="input text-xs input-bordered w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full mx-auto lg:w-40 max-w-xs lg:mr-2">
                            <label class="label">
                                <span class="label-text">End Date</span>
                            </label>
                            <input name='endDate' defaultValue={today} type="date" class="input text-xs input-bordered w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-80 lg:w-40 max-w-xs">
                            <label class="label">
                                <span class="label-text">Customer Code</span>
                            </label>
                            <div class="form-control w-80 lg:w-40">
                                <input name='code' type="text" defaultValue={selectedCustomer?.code} placeholder="Customer Code" class="input text-xs input-bordered border-dark-purple w-full lg:w-40 max-w-xs" />
                            </div>
                        </div>
                        <input type='submit' value='Search' className='btn btn-md btn-error w-80 mx-auto lg:w-20 text-white mt-4 lg:mt-9 lg:ml-2' />
                    </form>
                </div>
            </div>
            {isLoaded && <div className='text-right'>
                <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="btn btn-error text-white btn-xs mt-2 lg:mt-0"
                    table="table-to-xls"
                    filename={`Bank Statement- ${details.accountName}`}
                    sheet={`bankstatement-${details.accountName}`}
                    buttonText="Export to exel" />
                <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
            </div>
            }
            {isLoaded && <div ref={componentRef}>
                <div className='flex justify-center items-center mt-8'>
                    <div>
                        <img src={BusinessInfo.img} className="w-20 lg:w-44 lg:mr-20 lg:mb-4" alt="" />
                    </div>
                    <div className='lg:mr-40'>
                        <h1 className='text-xl lg:text-4xl text-textPrimary text-center'>{BusinessInfo.fullName}</h1>
                      {/* <h1 className='text-sm lg:text-xl text-textPrimary text-center'>{BusinessInfo.dealer}</h1> */}
                        <h1 className='text-xs text-textPrimary text-center'>{BusinessInfo.address}</h1>
                        <h1 className='text-xs lg:text-xl text-textPrimary text-center'>{BusinessInfo.mobile}</h1>
                    </div>
                </div>
                <div class="flex items-center justify-between">
                    <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
                    <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
                </div>
                <div class="flex items-center justify-between">
                    <hr class="border-b border-gray-300 w-full my-px" />
                    <hr class="border-b border-gray-300 w-full my-px" />
                </div>

                <div className='flex justify-between'>
                    <div className='text-left ml-20 mt-8 text-xs'>
                        <h4>Report Type: <span className='font-bold'>Customer Ledger Statement</span></h4>
                        <h4>Customer Name: {details?.name}</h4>
                        <h4>Customer Code: {details?.code}</h4>
                        <h4>Report Date Range: {details?.range}</h4>
                        <h4>Report Time: {details?.time}</h4>
                    </div>
                    <div className='w-40 ml-8 mt-4'>
                        <img src={details.img ? details?.img : person} alt="" />
                    </div>
                </div>

                <div className='mb-20'>
                    <div class="overflow-x-auto mt-8  text-xs">
                        <table id='table-to-xls' class="table w-full text-center shadow-xl rounded-lg">
                            <thead>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>SL</th>
                                    <th className='bg-primary text-white normal-case'>Date</th>
                                    <th className='bg-primary text-white normal-case'>Invoice No</th>
                                    <th className='bg-primary text-white normal-case'>Sale Amount</th>
                                    <th className='bg-primary text-white normal-case'>Collection Amount</th>
                                    <th className='bg-primary text-white normal-case'>Details</th>
                                </tr>

                            </thead>
                            <tbody>
                                {
                                    customerLedger.map((customer, index) => <tr>
                                        <td className='border border-primary'>{index + 1}</td>
                                        <td className='border border-primary'>{customer?.date}</td>
                                        <td className='border border-primary'>{customer?.invoice}</td>
                                        <td className='border border-primary'>{customer.remarks === "Sales Return" && customer.totalAmount ? "-" : customer?.totalAmount ? customer?.totalAmount : "-"}</td>
                                        {/* <td className='border border-primary'>{supplier?.remarks === "Purchase" ? supplier?.payment : supplier?.remarks === "Purchase Return" ? supplier?.purchaseReturn : supplier?.duePayment || "-"}</td> */}
                                        <td className='border border-primary'>{customer?.remarks === "Sale" ? customer?.collection : customer?.remarks === "Sales Return" ? customer?.salesReturn : customer?.collection || 0}</td>
                                        {/* <td className='border border-primary'>{customer?.collection ? customer?.collection : customer.salesReturn ? customer.salesReturn : "-"}</td> */}
                                        <td className='border border-primary'>{customer?.remarks}</td>
                                    </tr>)
                                }

                            </tbody>
                            <tfoot>
                                <tr>
                                    <th className='bg-primary text-white normal-case'></th>
                                    <th className='bg-primary text-white normal-case'>Opening Balance On {details?.startDate}</th>
                                    <th className='bg-primary text-white text-sm'>{opening}</th>
                                    <th className='bg-primary text-white text-sm'>{totalSaleAmount}</th>
                                    <th className='bg-primary text-white text-sm'>{totalCollectionAmount}</th>
                                    <th className='bg-primary text-white text-sm normal-case'>Closing: {opening + totalSaleAmount - totalCollectionAmount}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                </div>

            </div>}
        </div>
    );
};

export default CustomerLedgerReport;